/* eslint-disable */
export default {
  noResultFoundFor: '找不到结果:',
  search: '搜索',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
